var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { i18n } from '@easydata/core';
import { ExprTag } from '@easyquery/core';
import { domel } from '@easydata/ui';
import { DisplayFormatParser } from '../../../utils/display_format_parser';
;
import { SimpleColumnRendererCP } from './simple_column_renderer';
import { browserUtils } from '../../../utils/browser_utils';
var AggrFuncColumnRendererCP = /** @class */ (function (_super) {
    __extends(AggrFuncColumnRendererCP, _super);
    function AggrFuncColumnRendererCP() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayFormatParser = new DisplayFormatParser();
        return _this;
    }
    AggrFuncColumnRendererCP.prototype.getClassesToAdd = function () {
        return _super.prototype.getClassesToAdd.call(this) + " " + this.cssPrefix + "-row " + this.cssPrefix + "-row-column-aggr";
    };
    AggrFuncColumnRendererCP.prototype.getAttribute = function () {
        return this.panel
            .getContext()
            .getModel()
            .getAttributeByIdSafe(this.column.expr.args[0].value);
    };
    AggrFuncColumnRendererCP.prototype.getDefaultColumnCaption = function () {
        return this.getDefaultTitleText(this.baseAttr) + ' '
            + this.panel.getContext().getModel().getAggrFunctionCaption(this.column.expr.func);
    };
    AggrFuncColumnRendererCP.prototype.renderExpressionBlock = function () {
        var _this = this;
        var model = this.panel.getContext().getModel();
        var exprBlockBuilder = domel("div")
            .addClass(this.cssPrefix + "-expr-block", this.cssPrefix + "-expr-block-aggr")
            .addClass(browserUtils.getMobileCssClass());
        var format = model.getAggrFunctionFormat(this.column.expr.func);
        if (!format || format === '')
            return;
        var arrFormat = this.parseDisplayFormat(format);
        if (arrFormat.length === 0)
            return;
        var item = null;
        var arrLength = arrFormat.length;
        var _loop_1 = function (idx) {
            item = arrFormat[idx];
            if (item.type === 1) {
                if (this_1.isEditable()) {
                    var functionLink_1 = domel('a')
                        .attr('href', 'javascript:void(0)')
                        .text(item.text)
                        .on('click', function (ev) {
                        ev.stopPropagation();
                        _this.functionMenu.showMenu({
                            anchor: functionLink_1.toDOM(),
                            selectedIds: null,
                            itemSelectedCallback: function (data, items) {
                                if (data.id === "CUSTOMSQL") {
                                    _this.changeTypeToCustomSql();
                                }
                                else {
                                    _this.column.expr.func = data.id;
                                    _this.column.caption = '';
                                    _this.fireColumnChanged();
                                }
                            }
                        });
                    });
                    exprBlockBuilder
                        .addChild('div', function (builder) { return builder
                        .addClass(_this.cssPrefix + "-colelement", _this.cssPrefix + "-aggrfuncelement")
                        .addClass(browserUtils.getMobileCssClass())
                        .addChildElement(functionLink_1.toDOM()); });
                }
                else {
                    exprBlockBuilder
                        .addChild('div', function (b) { return b
                        .addClass(_this.cssPrefix + "-colelement", _this.cssPrefix + "-aggrfuncelement")
                        .addClass(browserUtils.getMobileCssClass())
                        .addChild('span', function (b) { return b
                        .text(item.text)
                        .title(item.text); }); });
                }
            }
            else if (item.type === 2) {
                exprBlockBuilder
                    .addChild('div', function (builder) { return builder
                    .addClass(_this.cssPrefix + "-colelement", _this.cssPrefix + "-attrelement")
                    .addClass(browserUtils.getMobileCssClass())
                    .addChildElement(_this.renderBaseExpression()); });
            }
            else if (item.type === 3) {
                exprBlockBuilder
                    .addChild('span', function (builder) { return builder
                    .addClass(_this.cssPrefix + "-colelement")
                    .addClass(browserUtils.getMobileCssClass())
                    .text(item.text)
                    .title(item.text); });
            }
        };
        var this_1 = this;
        for (var idx = 0; idx < arrLength; idx++) {
            _loop_1(idx);
        }
        return exprBlockBuilder.toDOM();
    };
    AggrFuncColumnRendererCP.prototype.renderColumnTypeButton = function () {
        var button = _super.prototype.renderColumnTypeButton.call(this);
        if (button) {
            button.firstElementChild.classList.add('aggregated');
            button.firstElementChild.setAttribute('title', i18n.getText('ButtonToSimple'));
        }
        return button;
    };
    AggrFuncColumnRendererCP.prototype.baseExpressionItemSelectedCallback = function (data, item) {
        var attrid = data.id;
        //this.column.expr.args[0].id = attrid;
        this.column.expr.args[0].setValue(attrid, true);
        this.column.caption = '';
        this.fireColumnChanged();
        return false;
    };
    AggrFuncColumnRendererCP.prototype.changeTypeToSimple = function () {
        var query = this.column.getQuery();
        query.changeColumnType(this.column, ExprTag.EntityAttribute);
        this.fireColumnChanged();
    };
    AggrFuncColumnRendererCP.prototype.parseDisplayFormat = function (format) {
        if (!format)
            return [];
        var result = [];
        var parser = this.displayFormatParser;
        parser.start(format);
        while (parser.next()) {
            var token = parser.getToken();
            var tokenText = parser.getTokenText();
            if (token === 'function') {
                result.push({ type: 1, text: tokenText });
            }
            else if (token === 'expression') {
                result.push({ type: 2 });
            }
            else if (token === 'text') {
                result.push({ type: 3, text: tokenText });
            }
        }
        return result;
    };
    AggrFuncColumnRendererCP.prototype.changeTypeHandler = function (ev) {
        this.changeTypeToSimple();
    };
    AggrFuncColumnRendererCP.prototype.processExtraButtonMenuItems = function (action, evt) {
        this.changeTypeToSimple();
        return true;
    };
    AggrFuncColumnRendererCP.prototype.getExtraButtonMenuItems = function () {
        return [{
                id: '__group',
                text: i18n.getText('ColTypeGroup'),
                items: [{
                        id: 'type',
                        text: i18n.getText('ColTypeSimple')
                    }]
            }];
    };
    return AggrFuncColumnRendererCP;
}(SimpleColumnRendererCP));
export { AggrFuncColumnRendererCP };
//# sourceMappingURL=aggrfunc_column_renderer.js.map